import React from "react";
import { Link, useParams } from "react-router-dom";
import { PageShell } from "../HomeV2/HomeV2";
import { POSTS } from "./insightsData";

const renderBody = (body) =>
  typeof body === "string"
    ? body
        .split("\n")
        .filter((line) => line.trim())
        .map((line) => <p key={line}>{line}</p>)
    : body;

// /insights/:id: a single news item or blog post, in the same theme as the rest of the site
const InsightsArticle = () => {
  const { id } = useParams();
  const post = POSTS.find((p) => p.id === id);

  if (!post) {
    return (
      <PageShell title="Insights | Dsider">
        <section className="hv2-section hv2-article-missing">
          <div className="hv2-container">
            <h1>We couldn’t find that post.</h1>
            <Link to="/insights" className="hv2-btn hv2-btn--primary">
              Back to Insights
            </Link>
          </div>
        </section>
      </PageShell>
    );
  }

  return (
    <PageShell title={`${post.title} | Dsider`} description={post.excerpt}>
      <section className="hv2-jobpage-hero hv2-article-hero">
        <div className="hv2-jobpage-hero__inner">
          <Link to="/insights" className="hv2-jobpage__back">
            ← Back to Insights
          </Link>
          <span className="hv2-pill">
            <i aria-hidden="true" />
            {post.type}
          </span>
          <h1>{post.title}</h1>
        </div>
      </section>

      <section className="hv2-section hv2-article">
        <div className="hv2-article__inner">
          <div className="hv2-article__media">
            <img src={post.image} alt="" />
          </div>
          <div className="hv2-article__body">
            {renderBody(post.body)}
            {post.source && (
              <p className="hv2-article__source">
                Source:{" "}
                <a href={post.source} target="_blank" rel="noopener noreferrer">
                  View the original post on LinkedIn
                </a>
              </p>
            )}
          </div>
          <Link to="/insights" className="hv2-btn hv2-btn--primary">
            More from Insights
          </Link>
        </div>
      </section>
    </PageShell>
  );
};

export default InsightsArticle;
